import styled, { keyframes } from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase } from 'library/styles/icon';

export const filter = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
  }

  100% {
    //filter: blur(0);
    opacity: 1;
    transform: scale(1);
  }
`;

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  //padding-top: 3px;

  background-image: linear-gradient(#2D3132, rgba(0, 0, 0, 0));
  background-size: 100% 54px;
  background-repeat: no-repeat;
`;

const Icon = styled(IconBase)`
  color: ${Colors.shade05};

  &:hover {
    color: ${Colors.shade08};
  }

  &.icon-options-vertical {
    float: right;
  }
`;

const Image = styled.img`
  position: relative;
  //height:auto;
  aspect-ratio: attr(width) / attr(height);
  // max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'inherit')};
  width: 100%;
  height: auto;
  border-radius: 8px;
  filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  z-index: 3;
  display: block;
  filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));
  
  &:hover {
    > div {
      opacity: 1;
    }
  }
`;

const Container = styled.div`
  width: 180px;
  padding: 12px;
  overflow: hidden; 
  box-sizing: border-box;
  transform: scale(${({ isLoaded }) => (isLoaded ? 1 : 0)});
  will-change: ${({ isLoaded }) => (isLoaded ? 'unset' : 'transform')};
  transition: transform 0.5s ease-out;
  
  ${({ isDeleted }) => isDeleted && `    
    cursor: not-allowed !important;
    background-color: ${Colors.redLight1};
    border-radius: 8px;
    opacity: 0.25;

    ${ImageWrapper} {
       cursor: not-allowed !important;
       pointer-events: none;
    }
  `}
  
  ${({ isSelected }) => isSelected && `    
    ${ImageOverlay} {
      opacity: 1;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
      background-color: rgba(${Colors.violetRgb}, 0.8);
    }
    
    ${Icon}.icon-check-inverse {
      color: ${Colors.shade08};      
    }
  `}

  ${({ isOpened }) => isOpened && `
    background-color: ${Colors.shade02};
    overflow: hidden;
    border-radius: 8px;
    color: ${Colors.shade08};
    
    h3 {
      color: inherit;
    }
    p {
      color: ${Colors.shade05};
    }
  `}

  img {
    display: block;
    max-width: 100%;
  }

  h3 {
    margin-top: 9px;
    margin-bottom: 3px;
  }
`;

export {
  Container, ImageWrapper, ImageOverlay, Icon, Image,
};
